import { createSelector } from 'reselect';
import moment from 'moment';

import getCurrentOrder from './getCurrentOrder';
import { ASAP_TIME } from '../constants';

export default createSelector([getCurrentOrder], currentOrder => {
  const { deliveryTimePrevious } = currentOrder;

  if (deliveryTimePrevious === ASAP_TIME) {
    return moment().format();
  }

  return deliveryTimePrevious
    ? moment(deliveryTimePrevious).format()
    : undefined;
});
